import { IconHand, IconTimes } from '@7shifts/sous-chef-base';
import type { ErrorType } from '@src/api/punchTypes';
import type { TranslationKey } from '@src/i18n/types';

type IconComponent = typeof IconHand;

export interface ErrorDisplayConfig {
    headerKey: TranslationKey;
    fallbackMessageKey: TranslationKey;
    Icon: IconComponent;
}

const EXPECTED_ERROR_ICON = IconHand;
const UNEXPECTED_ERROR_ICON = IconTimes;

const ERROR_CONFIG: Record<ErrorType, ErrorDisplayConfig> = {
    invalid_punch_id: {
        headerKey: 'error.invalidPunchId.header',
        fallbackMessageKey: 'error.invalidPunchId.body',
        Icon: EXPECTED_ERROR_ICON
    },
    break_too_short: {
        headerKey: 'error.breakTooShort.header',
        fallbackMessageKey: 'error.breakTooShort.body',
        Icon: EXPECTED_ERROR_ICON
    },
    health_check_failed: {
        headerKey: 'error.healthCheckFailed.header',
        fallbackMessageKey: 'error.healthCheckFailed.body',
        Icon: EXPECTED_ERROR_ICON
    },
    not_assigned_to_location: {
        headerKey: 'error.notAssignedToLocation.header',
        fallbackMessageKey: 'error.notAssignedToLocation.body',
        Icon: EXPECTED_ERROR_ICON
    },
    clock_in_too_early: {
        headerKey: 'error.clockInTooEarly.header',
        fallbackMessageKey: 'error.clockInTooEarly.body',
        Icon: EXPECTED_ERROR_ICON
    },
    shift_not_scheduled: {
        headerKey: 'error.shiftNotScheduled.header',
        fallbackMessageKey: 'error.shiftNotScheduled.body',
        Icon: EXPECTED_ERROR_ICON
    },
    network: {
        headerKey: 'error.network.header',
        fallbackMessageKey: 'error.network.body',
        Icon: UNEXPECTED_ERROR_ICON
    },
    server: {
        headerKey: 'error.serverOrUnknown.header',
        fallbackMessageKey: 'error.serverOrUnknown.body',
        Icon: UNEXPECTED_ERROR_ICON
    },
    unknown: {
        headerKey: 'error.serverOrUnknown.header',
        fallbackMessageKey: 'error.serverOrUnknown.body',
        Icon: UNEXPECTED_ERROR_ICON
    }
};

export function getErrorConfig(errorType: ErrorType): ErrorDisplayConfig {
    return ERROR_CONFIG[errorType];
}
